import { motion } from "framer-motion";
import { Mail, Phone, MapPin, Clock } from "lucide-react";

const CONTACT_INFO = [
  { icon: Mail, label: "Correo", value: "lucilaevaquerano@gmail.com", href: "mailto:lucilaevaquerano@gmail.com" },
  { icon: Phone, label: "WhatsApp", value: "7574-1979", href: "https://wa.me/50375741979" },
  { icon: MapPin, label: "Dirección", value: "Pasaje El Calvario #2-BB, Suchitoto, El Salvador", href: "https://maps.google.com/?q=Pasaje+El+Calvario+2-BB+Suchitoto+El+Salvador" },
  { icon: Clock, label: "Horario", value: "10:00 AM — 10:00 PM", href: null },
];

export const ContactSection = () => {
  return (
    <section id="contacto" data-testid="contact-section" className="py-24 md:py-32 bg-[#2D2A26]">
      <div className="max-w-6xl mx-auto px-4 sm:px-8 md:px-12">
        <motion.div initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, margin: "-100px" }} transition={{ duration: 0.8 }} className="text-center mb-16">
          <p className="overline text-[#A25F4B] mb-4">Visítanos</p>
          <h2 data-testid="contact-title" className="font-heading text-4xl md:text-5xl tracking-tight text-[#FAF7F2]">Contacto</h2>
        </motion.div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
          {/* Info + Map */}
          <div>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 mb-10">
              {CONTACT_INFO.map((item, i) => (
                <motion.div key={i} initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.5, delay: i * 0.1 }} data-testid={`contact-item-${i}`}>
                  <div className="inline-flex items-center justify-center w-10 h-10 border border-[#FAF7F2]/10 mb-3">
                    <item.icon size={18} className="text-[#A25F4B]" />
                  </div>
                  <p className="overline text-[0.6rem] text-[#FAF7F2]/40 mb-1">{item.label}</p>
                  {item.href ? (
                    <a href={item.href} target="_blank" rel="noopener noreferrer" data-testid={`contact-link-${i}`} className="text-[#FAF7F2]/80 font-body text-sm leading-relaxed hover:text-[#A25F4B] transition-colors duration-300">{item.value}</a>
                  ) : (
                    <p className="text-[#FAF7F2]/80 font-body text-sm leading-relaxed">{item.value}</p>
                  )}
                </motion.div>
              ))}
            </div>

            <motion.div initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.6, delay: 0.4 }}>
              <a href="https://wa.me/50375741979" target="_blank" rel="noopener noreferrer" data-testid="contact-whatsapp-button" className="overline text-[0.7rem] bg-[#3F4F34] text-[#FAF7F2] px-10 py-3.5 hover:bg-[#2B3822] transition-all duration-300 hover:-translate-y-0.5 inline-block">
                Escríbenos por WhatsApp
              </a>
            </motion.div>
          </div>

          {/* Google Maps */}
          <motion.div initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.8, delay: 0.3 }} data-testid="contact-map" className="aspect-square lg:aspect-auto lg:h-full min-h-[300px]">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3875.5!2d-89.028!3d13.938!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2sSuchitoto%2C+El+Salvador!5e0!3m2!1ses!2ssv!4v1700000000000"
              width="100%"
              height="100%"
              style={{ border: 0, minHeight: "300px" }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="Ubicación Suchimex - Suchitoto, El Salvador"
              className="w-full h-full"
            />
          </motion.div>
        </div>
      </div>
    </section>
  );
};
